import script from "./ShareLinkPop.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareLinkPop.vue?vue&type=script&setup=true&lang=js"

import "./ShareLinkPop.vue?vue&type=style&index=0&id=c981ac6e&lang=scss"

const __exports__ = script;

export default __exports__